import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface ArFulfillmentEventsAddedCancelNotifyFollowersProps extends BaseTemplateProps {
  request: {
    name: string
  }
}

export const ArFulfillmentEventsAddedCancelNotifyFollowers: TemplateDefinition<ArFulfillmentEventsAddedCancelNotifyFollowersProps> =
  {
    renderParams: (props: ArFulfillmentEventsAddedCancelNotifyFollowersProps) => ({
      messageKey: 'notificationsDomain.templates.arFulfillmentEventsAddedCancelNotifyFollowers',
      values: {
        eventName: props?.request?.name,
      },
    }),
    getLink: (props: ArFulfillmentEventsAddedCancelNotifyFollowersProps): string => {
      if (!props) return ''
      return '/app/admin/approvals-management/approval-requests-search?tool=fulfillment_events'
    },
  }
